import { gql } from '@apollo/client';

export const FILE_INGESTION_LOGS = gql`
  query FileIngestionLogs($page: Int!, $limit: Int!) {
    fileIngestionLogs(page: $page, limit: $limit) {
      totalCount
      pageInfo {
        page
        limit
        hasNextPage
        hasPrevPage
      }
      nodes {
        id
        fileName
        errorMessage
        recordCount
        rejectRecordCount
        ingestionTimestamp
        pipelineStatus
        fileStatus
        monthYear
        rejects {
          meterNumber
          reasonToReject
        }
      }
    }
  }
`;